<template>
  <Record class="RecordArticleBlueprint">
    <Row>
      <Column :sm="2">
        {{ siteName }}
      </Column>
      <Column :sm="2">
        {{ articleLabel }}
      </Column>
      <Column :sm="3">
        {{ $t('startedAt') }}
        {{ articleBlueprint.startedAt | isoDateTime }}
        <Loader
          v-if="articleBlueprint.isProcessing"
          class="sm" />
      </Column>
      <Column :sm="5">
        <code>{{ articleBlueprint.scheme }}</code>
      </Column>
    </Row>
    <div slot="meta">
      <template v-if="articleBlueprint.doneAt">
        {{ $t('done') }}
        {{ articleBlueprint.doneAt | relativeTime }} ({{ duration | relativeDuration }})
      </template>
      <Icon
        v-else-if="articleBlueprint.failedAt"
        name="exclamation" />
      <Btn
        v-if="hasError"
        class="xs ib light danger"
        @click="doShowError = true">
        {{ $t('viewError') }}
      </Btn>
    </div>
    <Modal
      v-if="doShowError"
      @close="doShowError = false">
      <pre>{{ articleBlueprint.failMessage }}</pre>
    </Modal>
  </Record>
</template>

<script>
import { ARTICLE_TYPES } from '@store/modules/article'
import Record from '@components/Record'
import { getters } from '@utils'

export default {
  components: {
    Record,
  },
  props: {
    articleBlueprint: { type: Object, required: true },
  },
  data() {
    return {
      doShowError: false,
    }
  },
  computed: {
    articleLabel() {
      const article = this.queryOne('article', this.articleBlueprint.articleId)

      if (!article) return null

      return article.type === ARTICLE_TYPES.BUYING_GUIDE
        ? article.topic
        : article.title
    },
    duration() {
      return this.articleBlueprint.doneAt.getTime() - this.articleBlueprint.startedAt.getTime()
    },
    hasError() {
      return !!this.articleBlueprint.failMessage
    },
    siteName() {
      return this.queryOne('site', this.articleBlueprint.siteId)?.name
    },
    ...getters(),
  },
}
</script>

<style lang="scss">
.RecordArticleBlueprint {
}
</style>

<i18n>
{
  "en": {
    "done": "Done",
    "link": "Link",
    "status": "Status",
    "startedAt": "Started:",
    "viewError": "View error"
  }
}
</i18n>
